// removed by extract-text-webpack-plugin
module.exports = {"stripe-button-el":"pages-Stripe-stripe-button-el","wide":"pages-Stripe-wide"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Stripe/index.css
// module id = 1820
// module chunks = 0